import { render } from "./NewsFeed.vue?vue&type=template&id=7a817506&scoped=true"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"

import "./news-feed.scss?vue&type=style&index=0&id=7a817506&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a817506"]])

export default __exports__